import { toJS } from 'mobx';
import * as services from './services'
import { Base64 } from 'js-base64'
import { print } from './print'
import { getTemplate } from './getTemplate'
import customProtocolCheck from 'custom-protocol-check'
import { requiredValidate, getHoverRow } from '../utils';

/**
 * @des batchPrint 直接打印
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  dataSourceAlias: String
 *  tableStoreKey: string，默认值：tableStore
 *  billNo: String // 列表页对应的单卡的billNo
 * }
 * @returns
 */
const batchPrint = async function (rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['dataSourceAlias', 'tableStoreKey', 'billNo']);
  const { dataSourceAlias = '', billNo = '', tableStoreKey = 'tableStore' } = options
  const selectedRows = getSelectedData(rootStore, tableStoreKey)

  const { utils = {}, pageStore = {}, context = {} } = rootStore;
  const { params = {}, query = {} } = pageStore

  if (selectedRows.length < 1) {
    utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8003A', '请选择目标数据后再进行批量操作！'))
    return
  }

  const needParams = {
    query: {
      ...query,
      url: `${location.href}/iuap-apcom-print/u8cprint/app/getTokenInfo`,
      busiObj: options.busiObj || query.busiObj
    }
  }
  const res = await services.tokenInfo(needParams)

  const queryData = {
    datasource: dataSourceAlias
  }
  if (billNo) {
    queryData.cCardKey = billNo
  }
  const directprintParams = {
    query: {
      ...query,
      ...queryData,
      busiObj: options.busiObj || query.busiObj
    },
    data: {
      wb_at: res.wb_at,
      yht_access_token: res.yht_access_token,
      yonyou_uid: res.yonyou_uid,
      appSource: params?.domainKey,
      classifyCode: params?.busiObj,
      printDomain: `${location.origin}/iuap-apcom-print`,
      meta: 5,
      lang: 'zh_CN',
      domainDataBaseByCode: params?.domainKey,
      multilingualFlag: true,
      newArch: true,
      sendType: 6,
      printcode: 'temp',
      serverUrl: `${location.origin}/ypd/print/getTemplateContent?domainKey=${params?.domainKey}`,
      tenantId: context?.tenantid ?? '',
      params: {
        billno: params?.billNo,
        context_path: '/ypd',
        ids: selectedRows.map(item => item.id),
        printcountswitch: true,
        printrefreshinterval: 1000
      }
    }
  }
  try {
    await services.directprint(directprintParams)
  } catch (error) {
    // 请求发送失败有两种情况，一是打印插件没启动，二是Safari等浏览器不支持访问 http://127.0.0.1。
    // 无论是哪种情况，先尝试下使用 custom protocol 的方式启动客户端
    const customUri = `PrintPlugin://${Base64.encode(JSON.stringify(directprintParams.data))}`
    console.error('custom protocol: ', customUri)
    customProtocolCheck(
      `PrintPlugin://${Base64.encode(JSON.stringify(directprintParams.data))}`,
      () => {
        console.log('直接打印自定义协议-回调1');
        utils.confirm(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8003B', '直接打印插件启动异常，如需帮助请点击确认！')).then(() => {
          window.open('https://cdn.yonyoucloud.com/iprint/downloadlist.html', '_blank')
        });
      },
      () => {
        console.log('直接打印自定义协议-回调2 ');
      }, 100
    );
  } finally {
    // cons
  }
}

/**
 * @des 打印预览
 * @param rootStore
 * @param options{
 *  // 必填字段
 *  tableStoreKey: string，默认值：tableStore
 * }
 * @returns
 */
const printPreview = async function (rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['tableStoreKey']);
  const { utils = {} } = rootStore;
  const { tableStoreKey = 'tableStore', dataSourceAlias = '' } = options
  const selectedRows = getSelectedData(rootStore, tableStoreKey)
  if (selectedRows?.length < 1) {
    utils.message.danger(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8003A', '请选择目标数据后再进行批量操作！'))
    return
  }
  // printcode打印模板的code
  const tempData = await getTemplate?.call(this, rootStore, { dataSourceAlias })
  const printcode = tempData?.data[0]?.templatecode ? tempData?.data[0]?.templatecode : ''
  print.call(this, rootStore, { printcode, ids: selectedRows.map(item => item.id), dataSourceAlias })
}

/**
 * @des 获取选中数据
 * @param rootStore
 * @param tableStoreKey 数据源绑定的store
 * @returns
 */
const getSelectedData = (rootStore: any, tableStoreKey: any) => {
  const arr: [] = []
  const list = rootStore?.[tableStoreKey]?.getSelectedRows?.()
  if (Array.isArray(list) && list.length) {
    list.forEach((item) => {
      arr.push(toJS(item?.data ?? {}))
    })
  }
  return arr
}

export {
  batchPrint,
  printPreview
}
